import {isMobile} from '../../../libs/shared/core/src/helpers/environment/mobileEnvHelpers';
import {SingleUseValue} from '../../../src/helpers/memoryHelpers';
import {PersistedStateProvider} from '../persistentState/persistedState';
import {bootOfflineAsync} from './bootOffline';
import {bootOnlineAsync} from './bootOnline';
import {BootResult, BootResultInternal} from './bootTypes';

/*
 * Constants.
 */

const shouldIncludeRawBoot = !isMobile();

/*
 * Api.
 */

export async function bootAsync(persistedStateProvider: PersistedStateProvider): Promise<BootResult> {
  const {initialPersistedState, rawBoot, initialState} = await bootOnlineOrOfflineAsync(
    persistedStateProvider,
  );
  return {
    initialPersistedState: initialPersistedState && new SingleUseValue(initialPersistedState),
    rawBoot: rawBoot && shouldIncludeRawBoot ? new SingleUseValue(rawBoot) : undefined,
    initialState,
  };
}

/*
 * Helpers.
 */

async function bootOnlineOrOfflineAsync(
  persistedStateProvider: PersistedStateProvider,
): Promise<BootResultInternal> {
  const offlineResult = await bootOfflineAsync(persistedStateProvider);
  if (offlineResult) {
    return offlineResult;
  }

  return await bootOnlineAsync(() => persistedStateProvider.tryClearPersistedStateAsync());
}
